import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareC = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler3') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler3', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Basalisk jaw!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Basalisk jaw!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareC}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareC